import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinGudang = createAsyncThunk(
    "gudang/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getMinMasterGudang",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.NamaGudang,
                        label: item.NamaGudang,
                        categoryName: item.CategoryName,

                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getGudang = createAsyncThunk(
    "gudang/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getMasterGudang",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertGudang = createAsyncThunk(
    "gudang/insert",
    async ({NamaGudang, CategoryID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("NamaGudang", NamaGudang);
        formData.append("CategoryID", CategoryID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"insertMasterGudang",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateGudang = createAsyncThunk(
    "gudang/update",
    async ({NamaGudang, GudangID, status, CategoryID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("NamaGudang", NamaGudang);
        formData.append("GudangID", GudangID);
        formData.append("status", status);
        formData.append("CategoryID", CategoryID);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"updateMasterGudang",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const gudangSlice = createSlice({
    name: "gudang",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinGudang.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinGudang.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinGudang.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getGudang.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getGudang.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getGudang.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertGudang.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertGudang.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertGudang.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateGudang.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateGudang.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateGudang.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const gudangSelector = (state) => state.gudang;
